export default __webpack_public_path__ + "static/media/icon-contract.eed47aaf.png";